export default function NotFound(){
    return(
        <>
        <p>Notfound</p>
        </>
    )
}